import Page from "../../../components/Page";
import {Box, Container, Grid, Tab, Tabs} from "@material-ui/core";
import React, {useState} from "react";
import GoogleTemplateTable from "./google/GoogleTemplateTable";
import CreateGoogleTemplateView from "./google/CreateGoogleTemplateView";
import MetaTemplateTable from "./meta/MetaTemplateTable";
import CreateMetaTemplateView from "./meta/CreateMetaTemplateView";
import LineTemplateTable from "./line/LineTemplateTable";
import CreateLineTemplateView from "./line/CreateLineTemplateView";
import {HasRole, useTabIndex} from "../../../common/Util";
import {RoleIdEnum} from "../../../generated/graphql";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
};

export default () => {
    const [tabIndex, setTabIndex] = useTabIndex();

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.PmManager]}>
            <Page title={"Template Page"}>
                <Container maxWidth={false} style={{ padding: "30px" }}>
                    <Tabs value={tabIndex} onChange={handleChange} aria-label="Ads Tabs">
                        <Tab label="Google報表模板" />
                        <Tab label="Meta報表模板" />
                        <Tab label="Line報表模板" />
                    </Tabs>
                    <TabPanel value={tabIndex} index={0}>
                        <Grid container spacing={2}>
                            <CreateGoogleTemplateView />
                            <GoogleTemplateTable />
                        </Grid>
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1}>
                        <Grid container spacing={2}>
                            <CreateMetaTemplateView />
                            <MetaTemplateTable />
                        </Grid>
                    </TabPanel>
                    <TabPanel value={tabIndex} index={2}>
                        <Grid container spacing={2}>
                            <CreateLineTemplateView />
                            <LineTemplateTable />
                        </Grid>
                    </TabPanel>
                </Container>
            </Page>
        </HasRole>
    );
};